import { type FC } from 'react';
import type { UserMessageProps } from './UserMessage.types';

// Helper component for rendering user messages
export const UserMessage: FC<UserMessageProps> = ({ message }) => {
  return <>{message.content}</>;
};
